import React from 'react';
import OwlCarousel from 'react-owl-carousel';

const IndexIntro = () => {
  return (
    <section className="bg-light pt-lg-9 pb-lg-9 pb-0 position-relative bg-white-right-half-30">
      <div className="container">
        <div className="row align-items-center py-7 py-md-8">
          <div className="col-lg-6">
            <h1 className="font-weight-normal">High Quality Software, Delivered to you.</h1>
            <p className="lead">We are a software development company that offer custom software development services.</p>
            <div className="mt-6 mb-5">
              <h6 className="font-weight-normal mb-lg-5">Technologies used</h6>
              <OwlCarousel items={5} className="owl-carousel" autoplay autoplayTimeout={2000} autoplayHoverPause loop nav margin={8}>
                <div className="item">
                  <img
                    className="img-fluid p-2"
                    src="images/technologies/amazon.svg"
                    alt="Amazon Web Services"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Amazon Web Services"
                  />
                </div>
                <div className="item">
                  <img
                    className="img-fluid p-2"
                    src="images/technologies/digital-ocean.svg"
                    alt="Digital Ocean"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Digital Ocean"
                  />
                </div>
                <div className="item">
                  <img
                    className="img-fluid p-2"
                    src="images/technologies/react.svg"
                    alt="React Js / React Natice"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="React Js / React Natice"
                  />
                </div>
                <div className="item">
                  <img
                    className="img-fluid p-2"
                    src="images/technologies/redux.svg"
                    alt="Redux"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Redux"
                  />
                </div>
                <div className="item">
                  <img
                    className="img-fluid p-2"
                    src="images/technologies/jestjs.svg"
                    alt="JEST - Javascript Testing Framework"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="JEST - Javascript Testing Framework"
                  />
                </div>
                <div className="item">
                  <img
                    className="img-fluid p-2"
                    src="images/technologies/webpack.svg"
                    alt="Webpack - Static module bundler for modern JavaScript applications"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Webpack - Static module bundler for modern JavaScript applications"
                  />
                </div>
                <div className="item">
                  <img
                    className="img-fluid p-2"
                    src="images/technologies/jquery.svg"
                    alt="jquery"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="jQuery"
                  />
                </div>
                <div className="item">
                  <img
                    className="img-fluid p-2"
                    src="images/technologies/bootstrap.svg"
                    alt="Bootstrap"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Bootstrap"
                  />
                </div>
                <div className="item">
                  <img
                    className="img-fluid p-2"
                    src="images/technologies/nodejs.svg"
                    alt="Node.js"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Node.js"
                  />
                </div>
                <div className="item">
                  <img
                    className="img-fluid p-2"
                    src="images/technologies/mongodb.svg"
                    alt="MongoDB"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="MongoDB"
                  />
                </div>
                <div className="item">
                  <img
                    className="img-fluid p-2"
                    src="images/technologies/git.svg"
                    alt="Git"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Git"
                  />
                </div>
                <div className="item">
                  <img
                    className="img-fluid p-2"
                    src="images/technologies/hcl-domino.png"
                    alt="HCL Domino"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="HCL Domino"
                  />
                </div>
                <div className="item">
                  <img
                    className="img-fluid p-2"
                    src="images/technologies/wordpress.svg"
                    alt="HCL Domino"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="WordPress"
                  />
                </div>
              </OwlCarousel>
            </div>
          </div>

          <div className="col-lg-5 offset-lg-1">
            <div className="position-relative">
              <div className="position-absolute top left mt-6 pt-8 ml-n9 z-index-9">
                <img className="svg-injector" src="images/svg/shape-06.svg" alt="svg" />
              </div>

              <div className="img-shadow-50">
                <img className="img-fluid position-relative" src="images/intro.jpg" alt="intro" />
              </div>
            </div>
          </div>
        </div>

        <div className="position-absolute bottom left w-100 d-none d-lg-block">
          <img className="svg-injector w-100 ie-h-50" src="images/svg/shape-11.svg" alt="svg" />
        </div>
      </div>
    </section>
  );
};

export default IndexIntro;
